import { ReactNode } from 'react'

type PermissionWrapperProps = {
  toCheck: { [key: string]: boolean }
  hasAtLeastOne: string | string[]
  fallback?: ReactNode | null
  children: ReactNode
}

export default function PermissionWrapper({
  toCheck,
  hasAtLeastOne,
  fallback = null,
  children,
}: PermissionWrapperProps): ReactNode {
  return hasAtLeastOnePermission(toCheck, hasAtLeastOne) ? children : fallback
}

export function hasAtLeastOnePermission(
  entityPermissions: { [key: string]: boolean },
  shouldHavePermission: string | string[]
): boolean {
  return Array.isArray(shouldHavePermission)
    ? shouldHavePermission.some((permission) => entityPermissions[permission])
    : entityPermissions[shouldHavePermission]
}
